import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEventUserInterface } from '../data/event-user.interface';
import { GtmStatsAdapterList } from './list';
import { DataKeyValueStringInterface } from '../../../data/key-value/string.interface';

export class GtmStatsAdapterEventUserSignIn implements StatsAdapterInterface {
  /**
   * Mapping of AuthenticationProviderType to string
   */
  private mapping: DataKeyValueStringInterface = {
    Facebook: 'Finish:Sign in with facebook',
    Google: 'Finish:Sign in with google',
    Email: 'Finish:Sign in with email',
  };

  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventUserInterface {
    return {
      event: 'Userbox',
      eventAction: this.mapping[this.context.local.authentication_provider] || '',
      eventLabel: new GtmStatsAdapterList(this.context).getData(),
    };
  }
}
